import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
// import { DatePickerInput } from "rc-datepicker";
import { DatePickerInput } from 'rc-datepicker';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import Modal_Frame from "../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import Data_Grid from "../biztran_controls/DataGrid";
import AddExpenseSheet from "./AddExpenseSheet";


const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/11/04';


const ExpenseSheetList = (props) => {

  const [FromDate, setFromDate] = useState(fromdate);
  const [TravelRequestID, setTravelRequestID] = useState('');
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [isOpen, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Count, setCount] = useState();
  const [Employee, setEmployee] = useState('');
  const [Manager, setManager] = useState('');
  const [TravelLocation, setTravelLocation] = useState('');
  const [Status, setStatus] = useState('');
  const [Statuscmb, setStatuscmb] = useState([]);
  const [ExpenseID, setExpenseID] = useState('');
  const [response, fetchData] = UseFetchData();

  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  const openModal = (row) => {
    debugger;
    setTravelRequestID(row.id);
    setOpen(true);
  };

  const handleOpenModal = () => {
    setExpenseID('');
    setOpen(true);
  };

  const StatusOption = [
    { id: "TR Requested", title: "TR Requested" },
    { id: "TR Approved", title: "TR Approved" },
    { id: "TR Rejected", title: "TR Rejected" },
    { id: "Travelling", title: "Travelling" },
    { id: "Exp Approved", title: "Exp Approved" },
    { id: "Exp Requested", title: "Exp Requested" },
    { id: "Exp Rejected", title: "Exp Rejected" },
    { id: "ACC Approved", title: "ACC Approved" },
    { id: "Paid", title: "Paid" },
  ];

  const PopulateData = () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("TravelRequestID", "");
    bodyFormData.append("LocationToTravel", TravelLocation);
    bodyFormData.append("EmpName", Employee);
    bodyFormData.append("Manager", Manager);
    bodyFormData.append("Status", Status);
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    bodyFormData.append("Page", "ExpenseList");
    fetchData("Reports/TravelReport", bodyFormData);
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: "Select",
        //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: "TravelRequestNo",
        headerName: "Travel Req No",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "TravelRequestDate",
        headerName: "Travel Req Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 210,
      },

      {
        field: "ExpenseSheetCreatedOn",
        headerName: "Exp Sheet Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 190,
      },
      {
        field: "EmpCode",
        headerName: "Emp Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "EmpName",
        headerName: "Emp Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      {
        field: "LocationFromTravel",
        headerName: "Loc From Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "LocationToTravel",
        headerName: "Loc To Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "ApprovalStatus",
        headerName: "Status",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ExpenseApprovedBy",
        headerName: "Mngr Approved By",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 210,
      },
      {
        field: "ExpenseApprovedOn",
        headerName: "Mngr Approved On",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 210,
      },
      {
        field: "AccountsApprovedBy",
        headerName: "Acc Approved By",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "AccountsApproverRemarks",
        headerName: "Acc Remarks",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },

    ];
    setColumns(gridCols);
    if (response.Main !== undefined) {
      debugger;
      setRows(response.Main);
      setCount(response.Main.length);
    }
  }, [response]
  );

  useEffect(() => {
    PopulateData();
  }, [])

  return (
    <div>
      <Paper elevation={0}>
        <Grid container="row">
          <Grid xs={12} md={4} sm={3} lg={2} xl={2} >
            <div style={{ width: "198px", marginLeft: 10, marginTop: -3 }}>
              <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
              <DatePickerInput
                onChange={(jsDate, dateString) => setFromDate(dateString)}
                locale="en"
                displayFormat="DD/MMM/YYYY"
                // className='my-react-component'
                onClear={() => { onFromClear(); }}
                showOnInputClick
                maxDate={new Date()}
                returnFormat="YYYY/MM/DD"
                defaultValue={defaultfromDate}
              />
            </div>
          </Grid>
          <Grid xs={12} md={4} sm={3} lg={2} xl={2} >
            <div style={{ width: "198px", marginLeft: 9, marginTop: -3 }}>
              <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
              <DatePickerInput
                onChange={(jsDate, dateString) => setToDate(dateString)}
                locale="en"
                displayFormat="DD/MMM/YYYY"
                className='my-react-component'
                onClear={() => { onToClear(); }}
                showOnInputClick
                maxDate={new Date()}
                returnFormat="YYYY/MM/DD"
                defaultValue={defaultToDate}
              >
              </DatePickerInput>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 10 }}>
            <BiztranControls.Select
              label="Status"
              id="Status"
              width="185px"
              options={StatusOption}
              onChange={(e) => setStatus(e.target.value)}
            />
          </Grid>
        </Grid>
        <br />
        <Grid container="row" style={{ marginTop: -5 }} >
          <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
            <div style={{ width: "100%", marginLeft: 2, marginTop: 1 }} >
              <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                <BiztranControls.Input
                  label="Employee"
                  id="Employee"
                  onChange={(e) => setEmployee(e.target.value)}
                />
              </div>
            </div>
          </Grid>
          <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
            <div style={{ width: "100%", marginLeft: 0.5, marginTop: 1 }} >
              <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                <BiztranControls.Input
                  label="Manager"
                  id="Manager"
                  onChange={(e) => setManager(e.target.value)}
                />
              </div>

            </div>
          </Grid>

          <div style={{ float: "left", marginTop: -22, width: "25%", marginRight: -100 }}>
            <BiztranControls.Button
              text="SEARCH"
              startIcon={<SearchIcon />}
              style={{ marginTop: '10%' }}
              onClick={() => {
                PopulateData();
              }}
            />
          </div>
          <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: -75 }}>
            <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
          </div>
        </Grid>

        {/* <Grid container direction="row" marginTop={10} style={{ paddingTop: 4 }}>
          <Grid xs={6} md={4} sm={8} lg={4} xl={3} style={{ marginTop: 15 }} >
            <div style={{ width: "100%", marginLeft: 10, marginTop: 2 }} >
              <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                <BiztranControls.Button
                  text="SEARCH"
                  startIcon={<SearchIcon />}
                  style={{ marginTop: '10%' }}
                  onClick={() => {
                    PopulateData();
                  }}
                />
              </div> */}
        {/* <div style={{ float: "left", marginTop: 0, paddingLeft: 5, width: "30%" }}>
                <BiztranControls.Button
                  text="ADD NEW"
                  startIcon={<AddCircleOutlineIcon />}
                  style={{ marginTop: '10%' }}
                  onClick={() => {
                    handleOpenModal();
                  }}
                />
              </div> */}
        {/* 
            </div>
          </Grid>
        </Grid> */}

        <Modal_Frame
          title="Expense Sheet"
          maxWidth="md"
          Height="400px"
          isOpen={isOpen}
          setOpen={setOpen}
        >
          <AddExpenseSheet
            TravelRequestID={TravelRequestID}
            setOpen={setOpen}
            PopulateData={PopulateData}
            // pagename={"ExpenseSheetList"}
            Status={Status}

          />
        </Modal_Frame>

        <BiztranControls.DataGrid
          rowHeight={25}
          headerHeight={34}
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          // autoHeight={true}
          Width="107%"

          Height="400px"
          hideFooter={false}

        />
      </Paper>
    </div>
  )
}

export default ExpenseSheetList;